module.exports = __webpack_public_path__ + "img/magagine.6d0a4c51.png";